import React from 'react'
import { Descriptions, Drawer } from 'antd'

const { Item } = Descriptions

export default function OrderDrawer({ visible, onClose, order }) {
	return (
		<Drawer 
            open={visible} 
            onClose={onClose} 
            title="Detalles de la Orden"
            width={500}
        >
			<Descriptions bordered size="small" column={1}>
                <Item label="Consecutivo">{order.sku}</Item>
                <Item label="Tipo de Orden">{order.order_type}</Item>
                <Item label="Fecha Orden">{order.registered_at}</Item>
                <Item label="Bodega Asociada">{order.location_sku}</Item>
            </Descriptions>

            { order.order_details.length > 0 && (
                <React.Fragment>
                    { order.order_details.map(detail => (
                        <>
                            <p className='mb-5 ml-10 mt-10'><strong>Item: </strong>{detail.sku}</p>
                            <Descriptions bordered size="small" column={1} key={detail.id}>
                                <Item label="Nombre" key={detail.id}>
                                    {detail.article_name}
                                </Item>
                                <Item label="Recepción Planeada" key={detail.id}>
                                    {detail.reception_planned_at}
                                </Item>
                            </Descriptions>
                        </>
                    )) }
                </React.Fragment>
            ) }
		</Drawer>
	)
}   